export function convertToHtml(text: string): string {
  return text.replace(/\n/g, '<br>');
}
